import { render, staticRenderFns } from "./CatalogType.vue?vue&type=template&id=7a3a1b97"
import script from "./CatalogType.vue?vue&type=script&lang=js"
export * from "./CatalogType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports